var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    style: {
      "enableBackground": "new 0 0 64 64"
    },
    xmlSpace: "preserve"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M42.7,29.3L42.7,29.3h-8v-8c0-1.6-1.1-2.7-2.7-2.7l0,0c-1.6,0-2.7,1.1-2.7,2.7v8h-8c-1.6,0-2.7,1.1-2.7,2.7 c0,1.6,1.1,2.7,2.7,2.7l0,0h8v8c0,1.6,1.1,2.7,2.7,2.7l0,0c1.6,0,2.7-1.3,2.7-2.7v-8h8c1.6,0,2.7-1.1,2.7-2.7 C45.3,30.4,44.3,29.3,42.7,29.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32,0C14.4,0,0,14.4,0,32s14.4,32,32,32s32-14.4,32-32S49.6,0,32,0z M32,58.7c-14.7,0-26.7-12-26.7-26.7S17.3,5.3,32,5.3 s26.7,12,26.7,26.7S46.7,58.7,32,58.7z"
  }))));
};
export default __webpack_public_path__ + "static/media/circle-plus.ca233678.svg";
export { SvgComponent as ReactComponent };